import { render, staticRenderFns } from "./VulnerabilityInCode.vue?vue&type=template&id=6aadf566&scoped=true"
import script from "./VulnerabilityInCode.vue?vue&type=script&lang=js"
export * from "./VulnerabilityInCode.vue?vue&type=script&lang=js"
import style0 from "./VulnerabilityInCode.vue?vue&type=style&index=0&id=6aadf566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadf566",
  null
  
)

export default component.exports